import gameBg from '@images/game-bg.webp';
import homeBg from '@images/home-bg.webp';
import border from '@images/border.svg';
import money1 from '@images/moneys/money-1.webp';
import moneyRetina1 from '@images/moneys/money-1@2x.webp';
import stone1 from '@images/stones/stone-1.webp';
import stoneRetina1 from '@images/stones/stone-1@2x.webp';
import stone2 from '@images/stones/stone-2.webp';
import stoneRetina2 from '@images/stones/stone-2@2x.webp';
import stone3 from '@images/stones/stone-3.webp';
import stoneRetina3 from '@images/stones/stone-3@2x.webp';
import stone4 from '@images/stones/stone-4.webp';
import stoneRetina4 from '@images/stones/stone-4@2x.webp';
import stone5 from '@images/stones/stone-5.webp';
import stoneRetina5 from '@images/stones/stone-5@2x.webp';
import land from '@images/land.webp';
import landRetina from '@images/land@2x.webp';
import run from '@images/run.webp';
import runRetina from '@images/run@2x.webp';
import jump from '@images/jump.webp';
import jumpRetina from '@images/jump@2x.webp';

export const mapping = {
  gameBackground: {
    '1x': gameBg
  },
  homeBackground: {
    '1x': homeBg
  },
  border: {
    '1x': border
  },
  land: {
    '1x': land,
    '2x': landRetina,
  },
  run: {
    '1x': run,
    '2x': runRetina,
  },
  jump: {
    '1x': jump,
    '2x': jumpRetina,
  },
};

export const stonesMapping = {
  'stone-1': {
    '1x': stone1,
    '2x': stoneRetina1,
    width: 106,
    height: 132,
  },
  'stone-2': {
    '1x': stone2,
    '2x': stoneRetina2,
    width: 176,
    height: 132,
  },
  'stone-3': {
    '1x': stone3,
    '2x': stoneRetina3,
    width: 134,
    height: 132,
  },
  'stone-4': {
    '1x': stone4,
    '2x': stoneRetina4,
    width: 112,
    height: 132,
  },
  'stone-5': {
    '1x': stone5,
    '2x': stoneRetina5,
    width: 208,
    height: 132,
  },
};

export const moneysMapping = {
  'money-1': {
    '1x': money1,
    '2x': moneyRetina1,
  },
};